import React, { useCallback, useEffect, useState } from 'react'
import { getDeviceTypeFromUserAgent } from '~/api/util'
import { cn, RectangleButton, BottomSheet } from '@yanolja-rnd/nol-design-system'
import { IcDone } from '@yanolja-rnd/nol-icons'
import { DomesticCartDayuseTimeLine } from '~/api/routes/domestic/cart/controller/type'

interface DayUseTimelinesBottomSheetProps {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
  timeLines: DomesticCartDayuseTimeLine[]
  initialTimeLine: DomesticCartDayuseTimeLine | undefined
  onChangeTimeLine: (timeLine: DomesticCartDayuseTimeLine) => void
}

const TimeLineText = ({
  timeLine,
  isActive,
  onClick,
}: {
  timeLine: DomesticCartDayuseTimeLine
  isActive: boolean
  onClick: () => void
}) => {
  return (
    <div
      className={cn(
        'flex h-48 cursor-pointer gap-10 px-16 py-4',
        isActive && 'rounded-8 bg-fill-neutral-weak'
      )}
      onClick={onClick}
    >
      <div
        className={cn(
          'flex h-full w-full items-center justify-start',
          isActive ? 'typography-subtitle-16-bold' : 'typography-subtitle-16-regular'
        )}
      >
        {timeLine.timeRangeText}
      </div>
      {isActive && (
        <div className="flex items-center">
          <IcDone className="size-24" />
        </div>
      )}
    </div>
  )
}

const DayUseTimelinesBottomSheet: React.FC<DayUseTimelinesBottomSheetProps> = ({
  isOpen,
  onClose,
  onConfirm,
  timeLines,
  initialTimeLine,
  onChangeTimeLine,
}) => {
  const [selectedTimeLine, setSelectedTimeLine] = useState<DomesticCartDayuseTimeLine | undefined>(
    initialTimeLine
  )
  const isActive = (timeLine: DomesticCartDayuseTimeLine) => {
    return selectedTimeLine?.checkInAt === timeLine.checkInAt
  }

  const deviceType = getDeviceTypeFromUserAgent()

  useEffect(() => {
    setSelectedTimeLine(initialTimeLine)
  }, [initialTimeLine])

  const changeButtonClick = useCallback(() => {
    if (selectedTimeLine) {
      onChangeTimeLine(selectedTimeLine)
    }
    onClose()
  }, [onClose, onChangeTimeLine, selectedTimeLine])

  return (
    <>
      <BottomSheet
        isOpen={isOpen}
        os={deviceType}
        height="half"
        header="대실 시간 변경"
        footer={
          <RectangleButton
            theme="filled_primary"
            weight="bold"
            fullWidth
            size="large"
            onClick={changeButtonClick}
          >
            변경하기
          </RectangleButton>
        }
        onClose={onClose}
        onBackdropClick={onClose}
        dialogOptions={{
          onBackdropClick: () => {
            deviceType === 'etc' && onClose()
          },
        }}
        // 모바일 뷰에서 바텀시트 닫힐 때 실행
        onCloseEnd={() => onConfirm()}
        // PC 뷰에서 바텀시트 닫힐 때 실행
        onAnimationEnd={() => !isOpen && onConfirm()}
        zIndex={1}
      >
        <div className={cn('grid gap-4 px-16 py-8', 'pc:px-0 pc:py-0')}>
          {timeLines.map((timeLine, index) => (
            <TimeLineText
              key={index}
              timeLine={timeLine}
              isActive={isActive(timeLine)}
              onClick={() => setSelectedTimeLine(timeLine)}
            />
          ))}
        </div>
      </BottomSheet>
    </>
  )
}

export default DayUseTimelinesBottomSheet
